import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-form-anteced-pers-patologicos',
  templateUrl: './form-anteced-pers-patologicos.component.html',
  styles: []
})
export class FormAntecedPersPatologicosComponent implements OnInit {

  total = 3;
  pagina = 1;

  constructor() { }

  ngOnInit() {
  }

  prevPaginado(pagina: number) {
    if (this.pagina - pagina < 1) {
      this.pagina = 1;
    } else {
      this.pagina = this.pagina - pagina;
    }
  }

  nextPaginado(pagina: number) {
    if (this.pagina + pagina > this.total) {
      this.pagina = this.total;
    } else {
      this.pagina = this.pagina + pagina;
    }
  }

}
